/* N2 « Maison » — slow reveals + smooth anchors. */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-n2-stagger]').forEach(function (parent) {
      var step = parseFloat(parent.getAttribute('data-n2-stagger')) || 0.16;
      Array.prototype.forEach.call(parent.children, function (child, i) {
        child.style.setProperty('--n2-delay', (i * step).toFixed(2) + 's');
      });
    });

    var els = document.querySelectorAll('.n2-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }

    document.querySelectorAll('a[data-n2-scroll]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        var t = document.querySelector(id);
        if (!t) return;
        ev.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Dondy free tier prefill → French (same guard as N1). */
(function () {
  'use strict';
  var FR = 'Bonjour, j’ai une question 😊';
  function fix() {
    document.querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"]').forEach(function (a) {
      try { var u = new URL(a.href); u.searchParams.set('text', FR); a.href = u.toString(); } catch (e) {}
    });
  }
  var n = 0; var t = setInterval(function () { fix(); if (++n > 20) clearInterval(t); }, 1000);
})();

/* Klaviyo once-per-session guard (same as N1). */
(function () {
  'use strict';
  var KEY = 'nc-klaviyo-shown';
  function guard() {
    var shown = false;
    try { shown = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    document.querySelectorAll('[class*="kl-private"]').forEach(function (f) {
      var isOverlay = String(f.className).indexOf('kl-private-reset-css') > -1 && f.offsetHeight > 200;
      if (!isOverlay) return;
      if (shown) f.style.display = 'none';
      else { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
    });
  }
  var n = 0; var iv = setInterval(function () { guard(); if (++n > 30) clearInterval(iv); }, 800);
})();


/* Round 7: on phones, tuck the WhatsApp bubble away while the buy button is on screen (it covered the button's right end). */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(max-width: 600px)').matches || !('IntersectionObserver' in window)) return;
  function init() {
    var btns = document.querySelectorAll('.product-form__buttons, product-form button[type="submit"], button[name="add"], .add-to-cart-button');
    if (!btns.length) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
      document.body.classList.toggle('n2-buy-visible', visible.size > 0);
    }, { threshold: 0.05 });
    btns.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* L’Atelier — coffret review: quantity stepper (− n +) and remove button per article (client request, 30 Sep 2026;
   replaces the ON/OFF switches). Changes go straight into the builder's own box store, so the article count, the totals
   and the add-to-cart payload all follow. Rules: the écrin has no controls; « + » respects each step's maximum and, for
   accessories, two per model; removing the personalised card also clears its message (restored by « Annuler »).
   Fails safe: if the builder's internals change and the store cannot be found, nothing is injected. */
(function () {
  'use strict';
  if (!/^\/apps\/box-builder\//.test(location.pathname)) return;

  // Easify class names: "boxProduct-module__summary_content_list__Vm" (build 695) or "boxProduct-module__summary_content_list" (711+)
  var ROW = '[class*="-module__summary_content_list"]';
  var ROW_RE = /^boxProduct(Mobile)?-module__summary_content_list(__[\w-]+)?$/;
  var REVIEW = '[el-type="BOX_REVIEW"]';
  var PER_MODEL_MAX = 2;
  var ICON_MINUS = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';
  var ICON_PLUS = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';
  var ICON_DELETE = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var store = null;
  var syncing = false;
  var timer = null;
  var order = {};       // boxKey -> [itemId, …] first-seen order (for « Annuler »)
  var lastRemoved = null;
  var notices = {};     // itemId -> { msg, until }

  function isRow(el) { return [].some.call(el.classList || [], function (c) { return ROW_RE.test(c); }); }
  function isMobileRow(el) { return [].some.call(el.classList || [], function (c) { return c.indexOf('boxProductMobile-module__summary_content_list') === 0; }); }
  function pick(root, name) {
    var re = new RegExp('-module__' + name + '(__[\\w-]+)?$');
    var els = root.querySelectorAll('[class*="' + name + '"]');
    for (var i = 0; i < els.length; i++) if ([].some.call(els[i].classList, function (c) { return re.test(c); })) return els[i];
    return null;
  }
  function fiberOf(el) { for (var k in el) if (k.indexOf('__reactFiber$') === 0) return el[k]; return null; }
  function rowInfo(row) {
    var f = fiberOf(row), info = { item: null, boxKey: null };
    for (var d = 0; f && d < 40; d++, f = f.return) {
      var p = f.memoizedProps || {};
      if (!info.item && p.item && p.item.id) info.item = p.item;
      if (!info.boxKey && p.box && typeof p.box.key === 'string' && p.box.items) info.boxKey = p.box.key;
      if (!store && p.value && p.value.current && typeof p.value.current.getState === 'function') {
        try { if (p.value.current.getState().boxes instanceof Map) store = p.value.current; } catch (e) {}
      }
      if (info.item && info.boxKey && store) break;
    }
    return info;
  }
  function steps() { try { return (store.getState().box_set || {}).box_set_step || []; } catch (e) { return []; } }
  function ruleOf(stepKey) {
    var s = steps().filter(function (x) { return x.key === stepKey; })[0];
    var c = s && s.conditions && s.conditions.filter(function (x) { return x.attribute === 'QUANTITY'; })[0];
    return c ? { op: c.condition, n: parseInt(c.value, 10) } : null;
  }
  function locked(item) {
    return (item.sources || []).some(function (src) { var r = ruleOf(src.stepKey); return r && r.op === 'IS_EQUAL_TO'; });
  }
  // accessories = the second step with a « ≤ N » quantity rule (écrin = N, vêtements ≤, accessoires ≤, carte & emballage free)
  function accessoriesKey() {
    var capped = steps().filter(function (s) { var r = ruleOf(s.key); return r && r.op === 'IS_LESS_THAN_OR_EQUAL_TO'; });
    return capped[1] ? capped[1].key : null;
  }
  function textAreaKeys() {
    var keys = [];
    steps().forEach(function (s) { (s.elements || []).forEach(function (e) { if (/TEXT_AREA|CUSTOM_FIELD/.test(e.type || '')) keys.push(e.key); }); });
    return keys;
  }
  function isPersonalisedCard(item) {
    var t = ((item.product && item.product.title) || item.title || '') + '';
    return /carte/i.test(t) && /personnalis/i.test(t) && !/sans personnalis/i.test(t);
  }
  function titleOf(item) { return ((item.product && item.product.title) || item.title || 'cet article') + ''; }
  function stepOf(item) { var s = item.sources || []; return s.length ? s[s.length - 1].stepKey : null; }
  function countStep(box, stepKey, productId) {
    var n = 0;
    box.items.forEach(function (it) {
      if (productId && !(it.product && it.product.id === productId)) return;
      (it.sources || []).forEach(function (x) { if (x.stepKey === stepKey) n++; });
    });
    return n;
  }
  function limitMessage(n) {
    var t = null;
    try { t = window.subscription_box_builder.general_translation.data.quantity_less_than_or_equal_validation_message; } catch (e) {}
    return (t || 'Vous ne pouvez pas ajouter plus de {maxQuantity} article(s).').replace('{maxQuantity}', n);
  }
  // how many more units of `item` (adding `add`) the rules allow; returns a message when refused
  function refuse(box, item, add) {
    var key = stepOf(item); if (!key) return null;
    var r = ruleOf(key);
    if (r && (r.op === 'IS_LESS_THAN_OR_EQUAL_TO' || r.op === 'IS_EQUAL_TO') && countStep(box, key) + add > r.n) return limitMessage(r.n);
    if (key === accessoriesKey() && item.product && countStep(box, key, item.product.id) + add > PER_MODEL_MAX) return 'Deux exemplaires au maximum par modèle.';
    return null;
  }

  function setBox(boxKey, patch) {
    var s = store.getState(), box = s.boxes.get(boxKey);
    if (!box) return false;
    var boxes = new Map(s.boxes);
    boxes.set(boxKey, Object.assign({}, box, patch));
    store.setState({ boxes: boxes });
    return true;
  }
  function note(id, msg) { notices[id] = { msg: msg, until: Date.now() + 4500 }; schedule(); setTimeout(schedule, 4600); }

  function changeQty(boxKey, id, delta) {
    var box = store.getState().boxes.get(boxKey); if (!box) return;
    var it = box.items.get(id); if (!it || locked(it)) return;
    var srcs = (it.sources || []).slice();
    if (delta > 0) {
      var why = refuse(box, it, 1); if (why) { note(id, why); return; }
      srcs.push(Object.assign({}, srcs[srcs.length - 1]));
    } else {
      if (srcs.length <= 1) return;
      srcs.pop();
    }
    var items = new Map(box.items);
    items.set(id, Object.assign({}, it, { sources: srcs, quantity: srcs.length }));
    setBox(boxKey, { items: items });
  }

  function removeItem(boxKey, id) {
    var box = store.getState().boxes.get(boxKey); if (!box) return;
    var it = box.items.get(id); if (!it || locked(it)) return;
    var entry = { boxKey: boxKey, id: id, item: JSON.parse(JSON.stringify(it)), stash: null, until: Date.now() + 8000 };
    var items = new Map(box.items); items.delete(id);
    var patch = { items: items };
    if (isPersonalisedCard(it) && box.customFields) {
      var cf = Object.assign({}, box.customFields), keep = {};
      textAreaKeys().forEach(function (k) { if (cf[k]) { keep[k] = cf[k]; cf[k] = ''; } });
      if (Object.keys(keep).length) { entry.stash = keep; patch.customFields = cf; }
    }
    lastRemoved = entry;
    setBox(boxKey, patch);
    setTimeout(schedule, 8100);
  }

  function undo() {
    var e = lastRemoved; lastRemoved = null;
    if (!e) return;
    var box = store.getState().boxes.get(e.boxKey); if (!box || box.items.has(e.id)) { schedule(); return; }
    var why = refuse(box, e.item, (e.item.sources || []).length);
    if (why) { var host = document.querySelector('.nc-rq-undo'); if (host) host.textContent = why; setTimeout(schedule, 4000); return; }
    var ids = order[e.boxKey] || [], pos = ids.indexOf(e.id), entries = [], placed = false;
    box.items.forEach(function (v, k) {
      if (!placed && pos > -1 && ids.indexOf(k) > pos) { entries.push([e.id, e.item]); placed = true; }
      entries.push([k, v]);
    });
    if (!placed) entries.push([e.id, e.item]);
    var patch = { items: new Map(entries) };
    if (e.stash) { var cf = Object.assign({}, box.customFields || {}); Object.keys(e.stash).forEach(function (k) { if (!cf[k]) cf[k] = e.stash[k]; }); patch.customFields = cf; }
    setBox(e.boxKey, patch);
  }

  function button(cls, label, html) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = cls; b.setAttribute('aria-label', label); b.innerHTML = html;
    return b;
  }
  function buildControl(boxKey, id, name) {
    var wrap = document.createElement('div');
    wrap.className = 'nc-rq';
    wrap.setAttribute('data-nc-id', id);
    var box = document.createElement('div'); box.className = 'nc-rq__box';
    var minus = button('nc-rq__btn nc-rq__minus', 'Diminuer la quantité de ' + name, ICON_MINUS);
    var val = document.createElement('span'); val.className = 'nc-rq__val'; val.setAttribute('aria-live', 'polite');
    var plus = button('nc-rq__btn nc-rq__plus', 'Augmenter la quantité de ' + name, ICON_PLUS);
    var del = button('nc-rq__del', 'Retirer ' + name + ' du coffret', ICON_DELETE);
    minus.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); changeQty(boxKey, id, -1); });
    plus.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); changeQty(boxKey, id, 1); });
    del.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); removeItem(boxKey, id); });
    box.appendChild(minus); box.appendChild(val); box.appendChild(plus);
    wrap.appendChild(box); wrap.appendChild(del);
    return wrap;
  }

  function sync() {
    if (syncing) return;
    var review = document.querySelector(REVIEW);
    if (!review) return;
    syncing = true;
    try {
      var rows = [].slice.call(review.querySelectorAll(ROW)).filter(isRow);
      var live = rows.map(function (row) { var i = rowInfo(row); return { row: row, item: i.item, boxKey: i.boxKey }; })
                     .filter(function (x) { return x.item && x.boxKey; });
      if (store && live.length) { try { if (!store.getState().boxes.has(live[0].boxKey)) { store = null; live.forEach(function (x) { rowInfo(x.row); }); } } catch (e) { store = null; } }
      if (!store || !live.length) return;
      var state = store.getState();
      state.boxes.forEach(function (box, k) {
        var ids = order[k] = order[k] || [];
        box.items.forEach(function (v, id) { if (ids.indexOf(id) < 0) ids.push(id); });
      });
      live.forEach(function (x) {
        var box = state.boxes.get(x.boxKey); if (!box) return;
        var it = box.items.get(x.item.id) || x.item;
        var ctrl = x.row.querySelector('.nc-rq');
        if (locked(it)) { if (ctrl) ctrl.parentNode.removeChild(ctrl); x.row.classList.remove('nc-rq-row'); return; }
        var qtyEl = pick(x.row, 'summary_content_title_quantity');
        if (!qtyEl) return;
        if (ctrl && ctrl.getAttribute('data-nc-id') !== x.item.id) { ctrl.parentNode.removeChild(ctrl); ctrl = null; }
        if (!ctrl) {
          ctrl = buildControl(x.boxKey, x.item.id, titleOf(it));
          qtyEl.parentNode.insertBefore(ctrl, qtyEl.nextSibling);
        } else if (ctrl.previousSibling !== qtyEl) {
          qtyEl.parentNode.insertBefore(ctrl, qtyEl.nextSibling);
        }
        if (!x.row.classList.contains('nc-rq-row')) x.row.classList.add('nc-rq-row');
        x.row.classList.toggle('nc-rq-m', isMobileRow(x.row));
        var q = String(it.quantity || (it.sources || []).length || 1);
        var val = ctrl.querySelector('.nc-rq__val'); if (val.textContent !== q) val.textContent = q;
        var minus = ctrl.querySelector('.nc-rq__minus'); var dis = (+q) <= 1;
        if (minus.disabled !== dis) minus.disabled = dis;
        // per-row notice (limits)
        var n = notices[x.item.id], nEl = x.row.querySelector(':scope > .nc-rq-notice');
        if (n && n.until > Date.now()) {
          if (!nEl) { nEl = document.createElement('p'); nEl.className = 'nc-rq-notice'; nEl.setAttribute('role', 'status'); x.row.appendChild(nEl); }
          if (nEl.textContent !== n.msg) nEl.textContent = n.msg;
        } else if (nEl) { nEl.parentNode.removeChild(nEl); delete notices[x.item.id]; }
      });
      // guidance + undo bar above the first list
      var firstRow = live[0].row;
      var hint = review.querySelector('.nc-rq-hint');
      if (!hint) {
        hint = document.createElement('p'); hint.className = 'nc-rq-hint';
        hint.textContent = 'Ajustez votre coffret : modifiez les quantités ou retirez un article, le total se met à jour.';
        firstRow.parentNode.insertBefore(hint, firstRow);
      }
      var bar = review.querySelector('.nc-rq-undo');
      if (lastRemoved && lastRemoved.until > Date.now()) {
        if (!bar) { bar = document.createElement('p'); bar.className = 'nc-rq-undo'; bar.setAttribute('role', 'status'); hint.parentNode.insertBefore(bar, hint.nextSibling); }
        var label = '« ' + titleOf(lastRemoved.item) + ' » a été retiré de votre coffret.';
        if (bar.getAttribute('data-for') !== lastRemoved.id) {
          bar.setAttribute('data-for', lastRemoved.id);
          bar.textContent = label + ' ';
          var u = document.createElement('button'); u.type = 'button'; u.className = 'nc-rq-undo__btn'; u.textContent = 'Annuler';
          u.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); undo(); });
          bar.appendChild(u);
        }
      } else if (bar) { bar.parentNode.removeChild(bar); lastRemoved = null; }
    } catch (e) {
      if (window.console && console.warn) console.warn('[nc-review-qty]', e);
    } finally {
      syncing = false;
    }
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 40); }
  function start() {
    new MutationObserver(function (muts) {
      if (syncing) return;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && (t.closest(REVIEW) || (t.querySelector && t.querySelector(REVIEW)))) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
